import { UserState, UserActionTypes, SET_USER_INFO, CLEAR_USER_INFO } from '../types/userTypes';

const initialState: UserState = {
  userInfo: null,
  isAuthenticated: false,
  // Direct access fields
  userName: '',
  email: '',
  familyName: '',
  givenName: '',
  token: '',
  provider: '',
  expiration: 0,
};

const userReducer = (state = initialState, action: UserActionTypes): UserState => {
  switch (action.type) {
    case SET_USER_INFO:
      return {
        ...state,
        userInfo: action.payload,
        isAuthenticated: true,
        // Extract and store direct access fields from payload
        userName: action.payload.username || '',
        email: action.payload.email || '',
        familyName: action.payload.familyName || '',
        givenName: action.payload.givenName || '',
        token: action.payload.idToken || '',
        provider: action.payload.provider || '',
        expiration: action.payload.tokenExpiration || 0,
      };
    case CLEAR_USER_INFO:
      return {
        ...state,
        userInfo: null,
        isAuthenticated: false,
        // Clear direct access fields
        userName: '',
        email: '',
        familyName: '',
        givenName: '',
        token: '',
        provider: '',
        expiration: 0,
      };
    default:
      return state;
  }
};

export default userReducer;
